import { Button, Form, Col, Offcanvas, Card, Row } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import WebService from "../../../utility/WebService";
import { Label } from "../../../components/Label/Label";
import HelperService from "../../../utility/HelperService";
import Select from 'react-select';
import { useNavigate } from "react-router-dom";
import UploadFile from "../../../components/UploadFile/UploadFile";
import { IoClose } from "react-icons/io5";
import DocIcon from "../../../assets/images/doc-icon.svg";
import { IFloorInfo, ITowerInfo } from "./ManageTower";

interface PropData {
    isShow: boolean;
    isClose: Function;
    data: IFloorInfo | null;
    towerData: ITowerInfo[];
    project_uuid: string;
    tower_obj: ITowerInfo | null;
}

interface formInterface {
    id: string;
    uuid: string;
    floor_name: string;
    units: any[];
    image: string;
    project_uuid: string;
    tower_id: string;
}

const ManageFloors = (props: PropData) => {
    const navigate = useNavigate();
    const { handleSubmit, formState: { errors }, control, watch, getValues, register, reset, setValue } = useForm<formInterface>({});
    const watchAllFields = watch();
    const [isEdit, setIsEdit] = useState<boolean>(false);
    const [projectOptions, setProjectOptions] = useState<any[]>([]);
    const [fileData, setFileData] = useState<any>(null); 

    useEffect(() => {         
        if (props.isShow) {
            if (props.data && !HelperService.isEmptyObject(props.data)) {
                reset(props.data);
                setIsEdit(true);
            } else {
                reset({});
                resetForm();
                setIsEdit(false);
            }
            !projectOptions.length && getProjectUnitList()
        }
    }, [props.isShow, props.data]);

    useEffect(() => {
        if (projectOptions.length) { 
            setValue('units', projectOptions.filter((option: any) => Array.isArray(watch().units) && (watch().units as any[]).includes(option.value)));
        }
    }, [projectOptions, props.isShow]);

    const handleFormSubmit = (data: formInterface) => {
        data.project_uuid = props.project_uuid;
        data.tower_id = props.tower_obj?.id || "";
        data.units = data.units.map(item => item.value);

        const url = "create-or-update-floor";
        WebService.postAPI({ action: url, body: data, id: "changePassword-btn" })
            .then(async (res: any) => {
                toast.success(res.message);
                if (fileData && fileData.file && !watchAllFields.id) {
                    uploadFile(fileData?.file, res.floor_id);
                } else {
                    closeModal(true, res.project_data);
                }
            })
            .catch(() => { });
    };

    const getProjectUnitList = () => {
        WebService.getAPI({ action: `get/project/unit/list?uuid=${props.project_uuid}` })
            .then((res: any) => {
                const list = res.list.map((item: any) => {
                    return { ...item, value: item.id, label: item.unit_name };
                });
                setProjectOptions(list);
            })
            .catch((e: any) => { });
    };

    const closeModal = (e: boolean, data?: ITowerInfo[]) => {
        reset();
        resetForm();
        props.isClose(e, data);
    };

    const resetForm = () => {
        setValue('floor_name', '');
        setValue('units', [] as any[]);
        setValue('id', '');
        setValue('image', '');
        setFileData(null);
    };

    const onUploadFile = (data: any, name: string, size: string) => {
        if (fileData) {
            toast.error("You can not upload more than one file");
            setFileData({ ...fileData });
            return;
        }
        const blob = URL.createObjectURL(data);
        var isImageExte = /(\.(jpg|jpeg|png))$/i;
        var isVideo = /(\.(mp4))$/i;
        var isPdf = /(\.(pdf))$/i;
        let type = "";

        if (isImageExte.test(name)) {
            type = "IMAGE";
        } else if (isVideo.test(name)) {
            type = "VIDEO";
        } else if (isPdf.test(name)) {
            type = "PDF";
        }
        if (isEdit) {
            uploadFile(data);
        }

        setFileData({
            type: type,
            image: blob,
            file: data,
            name: name,
            size: size,
        });
        setValue("image", name);
    };

    const uploadFile = (data: any, floorId?: string) => {
        WebService.fileUploadAPI({
            action: `upload/project-mark/image`,
            key: "image",
            file: data,
            body: { project_uuid: props.project_uuid, tower_id: props.tower_obj?.id || "", floor_id: floorId || watchAllFields.id },
            id: "project_create_update_btn",
        })
            .then(async (res: any) => {
                watchAllFields.id && setValue("image", res.file_name);
                toast.success("File uploaded successfully");
                !watchAllFields.id && closeModal(true, res.project_data);
            })
            .catch(async (error: any) => { });
    };

    const onDeleteImage = () => {
        setFileData(null);
        setValue("image", '' as any);
    };


    return (
        <>
            <Offcanvas show={props.isShow} onHide={props.isClose} placement="end" className="offcanvas.offcanvas-ex-large">
                <Offcanvas.Header closeButton><Offcanvas.Title>{isEdit ? "Edit Floor" : "Add Floor"}</Offcanvas.Title></Offcanvas.Header>
                <Offcanvas.Body className="form-style">
                    <form className="form-style" onSubmit={handleSubmit(handleFormSubmit)}  >
                        <Row>
                            <Col lg={12} md={6} sm={12} className="mb-3">
                                {/* Floor Name */}
                                <Controller
                                    control={control}
                                    name="floor_name"
                                    rules={{ required: "Please Enter Floor Name" }}
                                    render={({ field: { onChange, onBlur }, fieldState: { isTouched } }) => (
                                        <div className="mb-2">
                                            <Label title="Floor Name" showStar={true} />
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Floor Name"
                                                onChange={onChange}
                                                onBlur={onBlur}
                                                value={watchAllFields.floor_name}
                                            />
                                            {(errors["floor_name"]?.message || Boolean(errors["floor_name"]?.message) || (isTouched && !watchAllFields.floor_name)) && (
                                                <div className="login-error">
                                                    <Label title={errors.floor_name?.message || "Please Enter Floor Name."} modeError={true} />
                                                </div>
                                            )}
                                        </div>
                                    )}
                                />

                                <Controller
                                    control={control}
                                    name="units"
                                    rules={{ required: true }}
                                    render={({ field: { onChange } }) => (
                                        <Form.Group className="mb-3">
                                            <Label title="Units" showStar={true} />
                                            <div className="input-group mb-1">
                                                <Select
                                                    className="basic-single w-100"
                                                    classNamePrefix="select"
                                                    isSearchable={true}
                                                    options={projectOptions}
                                                    onChange={(selectedOptions: any) => { onChange(selectedOptions || []); }}
                                                    value={watch().units || []}
                                                    placeholder="Select Units"
                                                    isMulti={true}
                                                />
                                            </div>
                                            {errors.units && (<div className="login-error mb-3"><Label title={"Please Select Units"} modeError={true} /></div>)}
                                        </Form.Group>
                                    )}
                                />

                                {!fileData && !watchAllFields.image && <UploadFile
                                    key={new Date().getTime()}
                                    onChange={(data: any, name: string, size: string) => { onUploadFile(data, name, size); }}
                                    acceptFileType={["jpg", "jpeg", "pdf", "png"]}
                                    message="Upload or Drag and Drop image"
                                    acceptedSize={5}
                                />}

                                {watchAllFields.image && <Card className={`border p-2 d-inline-block px-3 mb-3 me-2`}>
                                    <div className="d-flex gap-3 align-items-center">
                                        <div className="me-1">
                                            <IoClose size={20} onClick={() => { onDeleteImage(); }} className="text-secondary opacity-50 hover-effect cursor-pointer close" />
                                        </div>
                                        <div> <img src={DocIcon} width={40} height={40} alt="" /> </div>
                                        <div>
                                            <p className="font-medium font-16 mb-0">{watchAllFields.image}</p>
                                        </div>
                                    </div>
                                </Card>
                                }

                            </Col>

                        </Row>
                        <div className="text-center border-top">
                            <Button variant="dark" className="btn-brand-1 px-5 mt-3 mb-3 me-2" type="submit" id="changePassword-btn" >
                                {isEdit ? "Update" : "Add"}
                            </Button>
                            <Button variant="light" className="btn-brand-1 px-5 mt-3 mb-3" type="button" onClick={() => closeModal(false)}>
                                Close
                            </Button>
                        </div>
                    </form>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
};

export default ManageFloors;
